import React from "react";
import "./App.scss";
import { Banner } from "components/banner/Banner";
import { Header } from "components/header/Header";
import { Card } from "components/Card/Card";
import { Footer } from "components/footer/Footer";
import { homeCardList } from "helper/data/home";

function App() {
  return (
    <>
      <Header />
      <div className="App">
        <Banner />
        <div className="container">
          <div className="vision-top-text">
            <h1 className="vision-heading">
              <strong>BiuBiuVPN: Browser Private VPN</strong>
            </h1>
            <p className="vision-description">
              BiuBiuVPN: Browser Private VPN is a powerful virtual private
              network application designed to provide users with a fast,
              secure, and efficient online experience. With BiuBiuVPN: Browser
              Private VPN, you can protect your privacy, optimize your network
              connection, and enjoy unlimited access globally.
            </p>
          </div>
          {homeCardList.map((card, i) => (
            <Card
              isImgLeft={(i + 1) % 2 === 0}
              key={card.desc}
              title={card.title}
              des={card.desc}
              img={card.img}
            />
          ))}
        </div>
        <div className="container privacy-frame">
          <div className="privacy-img-frame">
            <img
              src={require("assets/img/privacy_artwork_icon2x.png")}
              alt=""
            />
            <div className="privacy-bg"></div>
          </div>
          <div className="privacy-des-frame">
            <h1 className="title">
              <strong>Privacy is central to everything we do. </strong>
            </h1>
            <p className="text-alignment---center">
              At Supre VPN, privacy is one of our core values. Every product we
              create is designed to safeguard your data. In today’s complex
              world, we strongly believe that your data belongs to you alone. We
              take our responsibility to protect your information, and your
              trust in us, very seriously.
              <br />
              <br />
              <a
                href="/privacy-policy.html"
                target="_blank"
                className="link"
                rel="noreferrer"
              >
                Privacy Policy
              </a>
            </p>
          </div>
        </div>
        <div className="container world-map">
          <div className="word-map-text-frame">
            <h2>
              <strong>
                Available
                <br />
                Everywhere
              </strong>
            </h2>
            <p className="description">
              No matter what device you’re on – we’ve got you covered! BiuBiuVPN:
              Browser Private VPN is your perfect travel companion and is
              available on a large variety of platforms and devices.
            </p>
          </div>
          <div className="map-img"></div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default App;
